module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-main main-container"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "w3-container about-container"
  }, [_c('h1', {
    staticClass: "w3-xxxlarge"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('Items')))])]), _vm._v(" "), _c('hr', {
    staticClass: "w3-round"
  }), _vm._v(" "), _c('div', {
    staticClass: "items-images-container"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "items-images-thumbnail"
    }, [_c('div', {
      staticClass: "item-category-name-layer"
    }, [_c('router-link', {
      attrs: {
        "to": ("/termekeink/" + (item._id))
      }
    }, [_vm._v("\n            " + _vm._s(item.title[_vm.locale]) + "\n          ")])], 1), _vm._v(" "), _c('img', {
      attrs: {
        "src": ("static/images/items/thumbnails/" + (item.thumbnail))
      }
    })])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bebc083","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Items.vue
// module id = 941
// module chunks = 0